'use client';

import { tranText } from './tranText';
import getLocal from '@/app/utils/getLocal';
export default function MoreBtn({ winCallback }: any) {
    const { locale } = getLocal();
    const textObj = tranText[locale] || tranText['us'];
    const openHandle = () => {
        winCallback && winCallback('open');
    };
    return (
        <div className="eco-redeem-rewards-more-btn" onClick={openHandle}>
            {textObj.more_text}
            <svg width="7px" height="11px" viewBox="0 0 7 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="控件" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                    <g id="控件/Learn-More-17右箭头" transform="translate(-93.000000, -9.000000)" stroke="#2673FF" strokeWidth="1.5">
                        <g id="路径-2" transform="translate(94.000000, 9.000000)">
                            <polyline
                                transform="translate(0.449747, 5.449747) rotate(-135.000000) translate(-0.449747, -5.449747) "
                                points="-2.55025253 2.44974747 -2.55025253 8.44974747 3.44974747 8.44974747"
                            ></polyline>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
}
